// extracted by css-extract-rspack-plugin
var _1 = "ji";
var _2 = "h";
var _3 = "e1";
var _4 = "hq";
var _5 = "ez";
var _6 = "jh";
var _7 = "hi";
var _8 = "e0";
export { _1 as "additionalInformation", _2 as "content", _3 as "description", _4 as "imageDescription", _5 as "imageLoaderComponent", _6 as "momentItemComponent", _7 as "selected", _8 as "title" }
